module.exports = {
  ERP_PORT: process.env.ERP_PORT || 'http://localhost:4000',
  MOAI_PORT: process.env.MOAI_PORT || 'http://localhost:5000',
};



// WEBPACK FOOTER //
// ./src/services/env.js